module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.open
    }
  }, [_c('a', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "auto",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "fa fa-server icon text-white"
  }), _vm._v(" "), _c('span', [_vm._v("Comunicação DETRO")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-sub dk"
  }, [_vm._m(1), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'detro.tasks.list'
      },
      "label": "Tasks",
      "icon": "",
      "icon-color-class": "",
      "show": _vm.ACL.check('exibir_tasks', _vm.currentUser.id)
    }
  }), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'logs'
      },
      "label": "Logs",
      "icon": "",
      "icon-color-class": "",
      "show": _vm.ACL.check('exibir_logs', _vm.currentUser.id)
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right text-muted"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-right text"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-fw fa-angle-down text-active"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-sub-header"
  }, [_c('a', [_c('span', {
    staticClass: "text-muted teste"
  }, [_vm._v("Tasks")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a5f0b8b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/menu/Logs.vue
// module id = 1482
// module chunks = 17